import { Col, Form, FormGroup, Input, Button } from "reactstrap";
import Header from "./Header";
import eyeSlash from "../assets/images/icons/eye-slash.svg";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

// function ChangePassword() {
//     return (
//         <>
//         <Header/>
//             <Col lg={4} className='mx-auto mt-5'>
//                 <div className='text-center mb-4 pb-2'>
//                     <h2 className='register-cont'>Change Password</h2>
//                 </div>
//                 <Form className='form login-form'>
//                     <FormGroup className='mb-4 input-field-with-icon'>
//                         <span className='input-icon'><img src={eyeSlash}/></span>
//                         <Input type='password' placeholder='New password' />
//                     </FormGroup>
//                     <FormGroup className='mb-4 input-field-with-icon'>
//                         <span className='input-icon'><img src={eyeSlash}/></span>
//                         <Input type='password' placeholder='Confirm new password' />
//                     </FormGroup>
//                     <div className='text-center mt-5'>
//                         <Button type="submit" color="primary login-width">Set Password</Button>
//                     </div>
//                 </Form>
//             </Col>
//         </>
//     )
// }

function ChangePassword() {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (!email || !newPassword || !confirmPassword) {
      setError("All fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const response = await fetch(
        "https://tradbee-backend.zeroinfo.in/api/change-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
            password: newPassword,
          }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        toast.success("Password updated successfully!");
        setTimeout(() => navigate("/"), 2000);
      } else {
        setError(data.error || "Failed to update password.");
      }
    } catch (error) {
      console.error("Error:", error);
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <>
      <Header />
      <Col lg={4} className="mx-auto mt-5">
        <div className="text-center mb-4 pb-2">
          <h2 className="register-cont">Change Password</h2>
        </div>
        <Form className="form login-form" onSubmit={handleChangePassword}>
          <FormGroup className="mb-4 input-field-with-icon">
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormGroup>
          <FormGroup className="mb-4 input-field-with-icon">
            <span className="input-icon">
              <img src={eyeSlash} />
            </span>
            <Input
              type="password"
              placeholder="New password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </FormGroup>
          <FormGroup className="mb-4 input-field-with-icon">
            <span className="input-icon">
              <img src={eyeSlash} />
            </span>
            <Input
              type="password"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </FormGroup>
          {error && <div className="text-danger mb-3">{error}</div>}
          <div className="text-center mt-5">
            <Button type="submit" color="primary" className="login-width">
              Set Password
            </Button>
          </div>
        </Form>
      </Col>
      <ToastContainer />
    </>
  );
}

export default ChangePassword;
